if (window.location.pathname === "/crm") {
    const uncategorizedOptions = {
        responsive: false,
        columnDefs: [
            {
                orderable: false,
                render: function(data, type, row) {
                    return `<input type="checkbox" name="delete_ids" class="form-control-sm" value="${data}" data-type="${row.type}">`;
                },
                targets: [0]
            },
            {
                render: function(data, type, row) {
                    const crmType = row.type.toLowerCase();
                    return `<a href="/crm/${crmType}/${row.id}">${data ||
                        "---"}</a>`;
                },
                targets: [1]
            }
        ]
    };

    $(".companies-table").data("options", {
        responsive: false,
        columnDefs: [
            {
                render: function(data, type, row) {
                    return `<a href="/crm/company/${row.id}">${data}</a>`;
                },
                targets: [0]
            },
            {
                sort: "approved",
                render(data, type, row) {
                    if (type == "display") {
                        return data == 1 ? "Y" : data == 0 ? "N" : "Unknown";
                    }
                    return data;
                },
                targets: [3, 4]
            },
            {
                render: function(data, type, row) {
                    return data ? `<a href="mailto:${data}">${data}</a>` : "";
                },
                targets: 5
            }
        ]
    });

    $(".contacts-table").data("options", {
        columnDefs: [
            {
                render: function(data, type, row) {
                    return data
                        ? `<a href="/crm/contact/${row.id}">${data}</a>`
                        : "";
                },
                targets: 0
            },
            {
                render: function(data, type, row) {
                    return data
                        ? `<a href="/crm/company/${row.company_id}">${data}</a>`
                        : "";
                },
                targets: 2
            },
            {
                render: function(data, type, row) {
                    return data
                        ? `<a href="/crm/contact/${row.manager_id}">${data}</a>`
                        : "";
                },
                targets: 4
            },
            {
                sort: "approved",
                render(data, type, row) {
                    if (type == "display") {
                        return data ? (data == 1 ? "Y" : "Unknown") : "N";
                    }
                    return data;
                },
                targets: [6]
            }
        ]
    });

    $(".events-table").data("options", {
        responsive: false,
        columnDefs: [
            {
                render: function(data, type, row) {
                    return `<a href="/crm/event/${row.id}">${data}</a>`;
                },
                targets: [0]
            },
            {
                render: function(data, type, row) {
                    return data ? `<a href="mailto:${data}">${data}</a>` : "";
                },
                targets: 2
            }
        ]
    });

    $(".vendors-table").data("options", {
        columnDefs: [
            {
                render: function(data, type, row) {
                    return `<a href="/crm/vendor/${row.id}">${data}</a>`;
                },
                targets: [0]
            },
            {
                render: function(data, type, row) {
                    return data ? '<i class="fas fa-check"></i>' : "";
                },
                targets: [5, 6, 7]
            },
            {
                render: function(data, type, row) {
                    if (data == null || typeof data == "undefined") return data;
                    return `<a href="tel:${data}">${data}</a>`;
                },
                targets: [2, 3]
            },
            {
                render: function(data, type, row) {
                    if (data == null || typeof data == "undefined") return data;
                    return `<a href="mailto:${data}">${data}</a>`;
                },
                targets: [4]
            }
        ]
    });

    $(".hotels-table").data("options", {
        columnDefs: [
            {
                targets: [0],
                createdCell: function(td, cellData, rowData, row, col) {
                    if (
                        rowData.hasOwnProperty("not_matched") &&
                        rowData.not_matched.includes("name")
                    ) {
                        $(td).css("background-color", "#f5c6cb");
                    }
                },
                render: function(data, type, row) {
                    return `<a href="/crm/hotel/${row.id}">${data}</a>`;
                }
            },
            {
                targets: [1],
                createdCell: function(td, cellData, rowData, row, col) {
                    if (
                        rowData.hasOwnProperty("not_matched") &&
                        rowData.not_matched.includes("address")
                    ) {
                        $(td).css("background-color", "#f5c6cb");
                    }
                }
            },
            {
                targets: [5],
                createdCell: function(td, cellData, rowData, row, col) {
                    if (
                        rowData.hasOwnProperty("not_matched") &&
                        rowData.not_matched.includes("phone")
                    ) {
                        $(td).css("background-color", "#f5c6cb");
                    }
                }
            },
            {
                targets: [6],
                createdCell: function(td, cellData, rowData, row, col) {
                    if (
                        rowData.hasOwnProperty("not_matched") &&
                        rowData.not_matched.includes("fax")
                    ) {
                        $(td).css("background-color", "#f5c6cb");
                    }
                }
            },
            {
                render: function(data, type, row) {
                    if (type == "display") {
                        return data
                            ? '<i class="fas fa-check"></i>'
                            : '<i class="fas fa-times"></i>';
                    }

                    return data;
                },
                targets: [8]
            }
        ]
    });

    $(".uncategorized-table").data("options", uncategorizedOptions);

    $(window).on("/api/company/replace.success", (e, response, form) => {
        popup_close("editor-companies_replace");
        let id = form.find("[name='id']").val();
        let row = $(`[data-id="${id}"]`).closest("tr");
        if (row.hasClass("child")) row = row.prev();
        $(".companies-table")
            .DataTable()
            .row(row[0])
            .remove()
            .draw();
    });

    $(window).on("/api/contact/replace.success", (e, response, form) => {
        popup_close("editor-contacts_replace");
        let id = form.find("[name='id']").val();
        let row = $(`[data-id="${id}"]`).closest("tr");
        if (row.hasClass("child")) row = row.prev();
        $(".contacts-table")
            .DataTable()
            .row(row[0])
            .remove()
            .draw();
    });

    $(window).on("/api/hotel/replace.success", (e, response, form) => {
        popup_close("editor-hotels_replace");
        let id = form.find("[name='id']").val();
        let row = $(`[data-id="${id}"]`).closest("tr");
        if (row.hasClass("child")) row = row.prev();
        $(".hotels-table")
            .DataTable()
            .row(row[0])
            .remove()
            .draw();
    });

    $(window).on("popup_open", function(e, type, data) {
        if (
            type === "editor-companies_replace" &&
            typeof data !== "undefined"
        ) {
            const text = data.email
                ? `${data.name} <small>(${data.email})</small>`
                : data.name;
            $(`.popup[data-type="${type}"]`)
                .find(".label-name")
                .html(text);
        }
        if (type === "editor-contacts_replace" && typeof data !== "undefined") {
            const text = data.email
                ? `${data.name} <small>(${data.email})</small>`
                : data.name;
            $(`.popup[data-type="${type}"]`)
                .find(".label-name")
                .html(text);
        }
        if (type === "editor-hotels_replace" && typeof data !== "undefined") {
            const text = data.name;
            $(`.popup[data-type="${type}"]`)
                .find(".label-name")
                .html(text);
        }
    });

    $(window).on("popup_close", function(e, type, data) {
        if (type === "editor-hotels_replace") {
            window.app_data.replace_reference = false;
        }
    });

    $(window).on("/api/hotel/get.fetched", function(e, response) {
        window.app_data.hotel = { ...response };
    });

    $(".add-crm").on("click", function() {
        const type = $(this).data("type");
        const table = $(`.${type}-table`);

        popup_open(`editor-${table.data("id")}`);

        const display = $(`.popup[data-type="editor-${table.data("id")}"]`);

        $.each(display.find("form"), function() {
            $(this)
                .find("button[data-type='discard']")
                .click();
        });

        $(window).trigger("dt-add-opened");
    });

    $(".check-all").on("change", function() {
        $(`[name="delete_ids"][data-type="${$(this).data("type")}"]`).prop(
            "checked",
            $(this).is(":checked")
        );
    });

    $(".bulk-delete").on("click", function() {
        const type = $(this).data("type");
        const checked = $(`[name="delete_ids"][data-type="${type}"]:checked`);

        if (!checked.length) {
            return alert("No items were selected");
        }

        $(".check-all").prop("checked", false);

        const ids = Array.from(
            document.querySelectorAll('[name="delete_ids"]:checked')
        ).map(a => a.value);

        if (
            confirm(
                `Are you sure you want to delete ${checked.length} records?`
            )
        ) {
            $.ajax({
                url: "/api/uncategorized/delete",
                method: "POST",
                data: { ids, type },
                dataType: "json",
                success: function(response) {
                    let selector;

                    switch (type) {
                        case "Company":
                            selector = ".companies-uncategorized-table";
                            break;
                        case "Contact":
                            selector = ".contacts-uncategorized-table";
                            break;
                        case "Vendor":
                            selector = ".vendors-uncategorized-table";
                            break;
                        case "Hotel":
                            selector = ".hotels-uncategorized-table";
                            break;
                    }

                    if (selector) {
                        const table = $(selector);
                        table.DataTable().destroy();
                        table.data("options", uncategorizedOptions);
                        window.dataTableInstance(table);
                    }

                    Swal.fire({
                        title: "Deleted",
                        text: "Records have been deleted.",
                        heightAuto: false,
                        icon: "success"
                    });
                }
            });
        }
    });

    const handleSearch = _.debounce(function() {
        const searchValue = $(this).val();
        const tables = $(".data-table");
        let uncategorizedCount = 0;

        tables.each(function() {
            const table = $(this);

            if (!$.fn.dataTable.isDataTable(table)) {
                return;
            }

            tableRedraw(table, searchValue);
            const info = table.DataTable().page.info();
            let badge;
            let uncategorizedBadge;

            if (table.hasClass("companies-table")) {
                badge = $(".badge-companies");
            } else if (table.hasClass("contacts-table")) {
                badge = $(".badge-contacts");
            } else if (table.hasClass("vendors-table")) {
                badge = $(".badge-vendors");
            } else if (table.hasClass("hotels-table")) {
                badge = $(".badge-hotels");
            } else if (table.hasClass("uncategorized-table")) {
                uncategorizedBadge = $(".badge-uncategorized");

                if (table.hasClass("companies-uncategorized-table")) {
                    badge = $(".badge-uncategorized-companies");
                } else if (table.hasClass("contacts-uncategorized-table")) {
                    badge = $(".badge-uncategorized-contacts");
                } else if (table.hasClass("vendors-uncategorized-table")) {
                    badge = $(".badge-uncategorized-vendors");
                } else if (table.hasClass("hotels-uncategorized-table")) {
                    badge = $(".badge-uncategorized-hotels");
                }
            }

            if (info && info.recordsDisplay && searchValue) {
                badge.text(info.recordsDisplay);
                badge.removeClass("d-none");

                if (uncategorizedBadge) {
                    uncategorizedCount += info.recordsDisplay;
                    uncategorizedBadge.text(uncategorizedCount);
                    uncategorizedBadge.removeClass("d-none");
                }
            } else {
                badge.addClass("d-none");

                if (uncategorizedBadge && !uncategorizedCount) {
                    uncategorizedBadge.addClass("d-none");
                }
            }
        });
    }, 100);

    function tableRedraw(table, search = false) {
        const tableInstance = table.DataTable();
        if (search !== false) {
            tableInstance.search(search).draw();
        } else {
            tableInstance.columns.adjust().draw();
        }
    }

    $("[name='crm_search']").on("keyup", handleSearch);
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/admin/crm.js